export default __webpack_public_path__ + "static/100--stacked-area-12f76636bbbfceab4f72e8f1c128621e.png";